import { genSaltSync } from 'bcryptjs'

export function generateHash() {
  const saltRounds = 10;
  const salt = genSaltSync(saltRounds);

  return salt
}